import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import Headline from '../../ui/Headline';
import PageHeader from '../PageHeader';
import { LOGO_SIZE } from '../../ui/Logo';
import CountdownTimer from '../../components/CountowntTimer';
import PageBottomContent from '../PageBottomContent';
import PageMainContent from '../PageMainContent';
import GameNavBar from '../../components/GameNavBar';
import { GAME_END_TIME, GAME_START_TIME, GAME_TIME_LEFT, REMAINING_MINUTES_FOR_NOTIFY, } from '../../app.config.vars/stored';
import { selectGameStatus, setGameStatus } from '../../store/slices/rallyGame';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../app.config.vars/routes';
import { generateIdRoutePath, getAtomFormattedDate } from '../../helpers';
import { GAME_DB } from '../../db/game';
import { useAppDispatch } from '../../store';
import { useSelector } from 'react-redux';
import { setIsModalOpen, setModalContent } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
const GamePageLayout = ({ rally, showGameResult, onNavButtonClick, children, controls, }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const gameStatus = useSelector(selectGameStatus);
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [gameTimeLeft, setGameTimeLeft] = useState(null);
    useEffect(() => {
        const handleGameStatusChange = async () => {
            if (gameStatus !== 'active') {
                if ((gameStatus === 'can-be-completed' || gameStatus === 'timeout') &&
                    !localStorage.getItem(GAME_END_TIME)) {
                    localStorage.setItem(GAME_END_TIME, getAtomFormattedDate(Date.now()));
                }
                setIsTimerRunning(false);
                await GAME_DB.SET.gameStatus(gameStatus);
            }
            else {
                const currentGameTimeLeft = localStorage.getItem(GAME_TIME_LEFT);
                if (currentGameTimeLeft) {
                    setGameTimeLeft(+currentGameTimeLeft);
                }
                else {
                    localStorage.setItem(GAME_START_TIME, getAtomFormattedDate(Date.now()));
                    if (rally.maxDuration) {
                        setGameTimeLeft(rally.maxDuration * 60);
                    }
                }
                setIsTimerRunning(true);
            }
            if (!showGameResult) {
                if (gameStatus === 'timeout' && rally) {
                    navigate(generateIdRoutePath(APP_ROUTES.rallyGameResult, rally?.uuid));
                }
            }
        };
        if (gameStatus) {
            handleGameStatusChange();
        }
    }, [gameStatus]);
    const onRemain = () => {
        dispatch(setIsModalOpen(true));
        dispatch(setModalContent(MODAL_CONTENT.timeExpireNotification.key));
    };
    const onTimeExpired = async () => {
        dispatch(setGameStatus('timeout'));
    };
    const onTick = (timeLeft) => {
        localStorage.setItem(GAME_TIME_LEFT, timeLeft.toString());
    };
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { logoSize: LOGO_SIZE.SMALL, logoLink: '/', title: _jsx(Headline, { title: rally.publicTitle, type: 'h1', layout: 4, spaceBottom: false }), countDownTimer: gameTimeLeft !== null && (_jsx(CountdownTimer, { duration: gameTimeLeft, running: isTimerRunning, onRemain: onRemain, onTimeExpired: onTimeExpired, remainThreshold: REMAINING_MINUTES_FOR_NOTIFY * 60, onTick: onTick })) }), _jsx(PageMainContent, { children: _jsxs("div", { className: "rally-game-page-container", children: [showGameResult ? (gameStatus === 'active' && (_jsx(GameNavBar, { onNavButtonClick: onNavButtonClick, isLinearRally: rally.isLinear }))) : (_jsx(GameNavBar, { onNavButtonClick: onNavButtonClick, isLinearRally: rally.isLinear })), children] }) }), _jsx(PageBottomContent, { children: controls })] }));
};
export default GamePageLayout;
